module.exports = __webpack_public_path__ + "img/video-tag.8811b27d.svg";